// src/lib/ws.ts
import { WS_ORIGIN } from '../config';

// ws.ts

// Ensure the base has a /ws suffix (exactly once)
function ensureWsBase(rawBase: string): string {
  // strip trailing slashes first
  const base = (rawBase || "").replace(/\/+$/, "");
  if (base.endsWith("/ws")) return base;           // already good
  return base + "/ws";
}

// Always join base + path safely
function joinWs(base: string, path: string): string {
  const p = (path || "").startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

export function openWS(path: string) {
  // If your env is e.g. wss://api.monivue.io, we’ll add /ws here.
  const base = ensureWsBase(WS_ORIGIN);
  const url  = joinWs(base, path);
  // Optional: quick debug to verify exact URL you’re dialing
  // console.debug("WS dial:", url);
  return new WebSocket(url);
}

type ActiveCamera = { id: string; online: boolean; source?: string; ts?: number };

export function openCameraVideoWS(camera: string | ActiveCamera) {
  const id   = typeof camera === "string" ? camera : camera.id;
  const base = ensureWsBase(WS_ORIGIN);
  const url  = joinWs(base, `/video/${encodeURIComponent(id)}`);
  return new WebSocket(url);
}

